import axiosInstance from 'src/api/axios';

import { AdminType } from 'src/types';
import { DefaultResponse } from 'src/api/api.types';
import { DeleteTenantAdminRequest, InviteAdminRequest, ResendAdminInviteRequest } from './tenantSuperAdmin.types';

class TenantSuperAdminService {
  private api = axiosInstance;

  public getMany = (id: number): Promise<DefaultResponse<AdminType[]>> => {
    return this.api.get(`tenants/${id}/admins`);
  };

  public invite = ({ id, body }: InviteAdminRequest): Promise<any> => {
    return this.api.post(`tenants/${id}/admins/invite`, body);
  };

  public resendInvite = ({ tenantId, adminId }: ResendAdminInviteRequest): Promise<void> => {
    return this.api.post(`tenants/${tenantId}/admins/invite/resend/${adminId}`);
  };

  public delete = ({ tenantId, adminId }: DeleteTenantAdminRequest): Promise<void> => {
    return this.api.delete(`tenants/${tenantId}/admins/${adminId}`);
  };
}

export const tenantSuperAdminService = new TenantSuperAdminService();
